import { configureStore } from '@reduxjs/toolkit';

import { Routes } from 'shared/routes';

import { baseApi } from './baseApi';
import { setupUnauthorizedHandler } from './unauthorizedHandler';

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
});

setupUnauthorizedHandler({
  onSessionExpired: () => {
    store.dispatch(baseApi.util.resetApiState());

    if (window.location.pathname !== Routes.frontend.loginPath) {
      window.location.assign(Routes.frontend.loginPath);
    }
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
